import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyCornerstone = lazy(() => import('./svg-components/cornerstone'));

const Cornerstone = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyCornerstone {...rest} />
  </Suspense>
);

export default Cornerstone;
